import { isProduction as f } from "../../util/environment/index.js";
import * as s from "ramda";
import * as u from "ramda-adjunct";
import { useCallback as m } from "react";
import { useTranslation as g } from "react-i18next";
const b = () => {
  const { t: e } = g(), i = m((r) => s.pathOr(
    0,
    ["networkError", "result", "errors", 0, "extensions", "subCode"],
    r
  ), []);
  return {
    getErrorMessage: m(
      (r) => {
        const o = e("error.message.fallback");
        if (s.has("code", r)) {
          const t = r, { code: a, message: n } = t;
          return e([`error.message.web.${a}`, n]);
        }
        if (s.has("graphQLErrors", r)) {
          const t = i(r);
          if (t !== 0)
            return e([`error.message.api.${t}`, o]);
          const { graphQLErrors: a, networkError: n } = r;
          if (f()) {
            if (u.isNotNil(n)) {
              const c = s.propOr(-1, "statusCode", n);
              return e([`error.message.http.${c}`, o]);
            }
          } else if (u.isNotNilOrEmpty(a))
            return s.pathOr(o, [0, "message"], a);
        }
        return s.is(Error, r) ? r.message : o;
      },
      [i, e]
    ),
    getErrorSubCode: i
  };
};
export {
  b as default
};
//# sourceMappingURL=useErrorHandler.js.map
